interface UrlParams {
    qr: string;
    nfc: string;
    service: string;
}

export function getUrlParams(key: string): string | null;
export function getUrlParams(): UrlParams;
export function getUrlParams(key = ''): string | null | UrlParams {
    const urlParams = new URLSearchParams(window.location.search);

    if (key) {
        return urlParams.get(key);
    }

    return {
        qr: urlParams.get('qr') ?? '',
        nfc: urlParams.get('nfc') ?? '',
        service: urlParams.get('service') ?? '',
    };
}
